<template>
  <div>
    <b-modal class="modal-lg" id="emailModal" ref="email-modal" :title="emailModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo(emailModal.modalData.entries)" @hide="resetModal('main'); clearModal();">
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'at']" size="1x" class="mr-2"/> {{ emailModal.modalData.title }}</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
      </template>
      <template slot="default">
        <div class="vld-parent text-center">
          <div autofocus>
            <!--<div @transitioncancel="loaderStopped()">-->
              <loading
              :active.sync="modalIsBusy"
              :can-cancel="false"
              :color="'#047bf8'"
              :loader="'dots'"
              :is-full-page="false"></loading>
            <!--</div>-->
            <div v-if="!modalIsBusy" >
              <template v-if="emailModal.modalData.entries == 'single'">
                <h5 class="py-2">{{ t('docEmailModalHeading','docEmailModalHeading') }}</h5>
                <h6 class="py-2">{{ t('docEmailModalDesc','docEmailModalDesc') }}</h6>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="email-subject" class="d-block">{{t('labelSubject','labelSubject') }}</label>
                    <input id="email-subject" v-model="emailModal.updateData.email_subject" class="form-control" :placeholder="t('labelSubject','labelSubject')" type="text" required>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="email-from" class="d-block">{{t('labelFrom','labelFrom') }}</label>
                    <span id="email-from" class="form-control text-lightgray">
                      {{ clientEmailAddress }}
                    </span>
                  </div>
                  <div class="form-group col-md-5">
                    <label for="email-to" class="d-block">{{t('labelTo','labelTo') }}</label>
                    <b-form-textarea id="email-to" v-model="emailModal.updateData.email_to" class="form-control" rows="5" max-rows="5" required @change="updateContacts()">
                    </b-form-textarea>
                  </div>
                  <div class="align-self-center col-md-2">
                    <strong class="text-size-large text-uppercase">{{t('labelOr','labelOr') }}</strong>
                  </div>
                  <div class="form-group align-self-center col-md-5">
                    <label for="address-book" class="text-size-normal d-block">{{t('labelChooseRecipient','labelChooseRecipient') }}</label>
                    <b-button size="md" id="address-book"
                      @click.stop.prevent="modalCreator({id: 'modalAddressBook', title: t('addressBookModalHead','addressBookModalHead'),  level: 'sub', parent: 'email', open: 'open'}, emailModal.docuData, $event.target)">
                        {{ t('addressBookButtonText','addressBookButtonText') }}
                    </b-button>
                  </div>
                    <label for="email-message" class="d-block">{{t('labelMessage','labelMessage') }}</label>
                    <b-form-textarea id="email-message" v-model="emailModal.updateData.email_message" class="form-control" rows="5" max-rows="5">
                    </b-form-textarea>
                    <!--
                    <label for="email-levels" class="d-block">{{t('labelAttachRelatedDocuments','labelAttachRelatedDocuments') }}</label>
                    <span>{{ t('docEmailModalDescAttachRelated1','docEmailModalDescAttachRelated1') }} </br> {{ t('docEmailModalDescAttachRelated2','docEmailModalDescAttachRelated2') }}</span>
                    <input id="email-levels" v-model="emailModal.updateData.doc_levels" class="form-control col-2" :placeholder="0" type="text">
                  -->
                </div>
              </template>
              <template v-if="emailModal.modalData.entries == 'multi'">
                <template v-if="emailModal.docuData.docsChecked.length">
                  <h5 class="py-2">{{ t('docEmailModalHeading','docEmailModalHeading') }}</h5>
                  <h6 class="py-2">{{ t('docEmailModalDesc','docEmailModalDesc') }}</h6>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="email-subject" class="d-block">{{t('labelSubject','labelSubject') }}</label>
                      <input id="email-subject" v-model="emailModal.updateData.email_subject" class="form-control" :placeholder="t('labelSubject','labelSubject')" type="text" required>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="email-from" class="d-block">{{t('labelFrom','labelFrom') }}</label>
                      <span id="email-from" class="form-control text-lightgray">
                        {{ clientEmailAddress }}
                      </span>
                    </div>
                    <div class="form-group col-md-5">
                      <label for="email-to" class="d-block">{{t('labelTo','labelTo') }}</label>
                      <b-form-textarea id="email-to" v-model="emailModal.updateData.email_to" class="form-control" rows="5" max-rows="5" required @change="updateContacts()">
                      </b-form-textarea>
                    </div>
                    <div class="align-self-center col-md-2">
                      <strong class="text-size-large text-uppercase">{{t('labelOr','labelOr') }}</strong>
                    </div>
                    <div class="form-group align-self-center col-md-5">
                      <label for="address-book" class="text-size-normal d-block">{{t('labelChooseRecipient','labelChooseRecipient') }}</label>
                      <b-button size="sm" id="address-book"
                        @click.stop.prevent="modalCreator({id: 'modalAddressBook', title: t('addressBookModalHead','addressBookModalHead'), level: 'sub', parent: 'email', open: 'open'}, emailModal.docuData, $event.target)"
                        class="mr-2">
                          {{ t('addressBookButtonText','addressBookButtonText') }}
                      </b-button>
                    </div>
                      <label for="email-message" class="d-block">{{t('labelMessage','labelMessage') }}</label>
                      <b-form-textarea id="email-message" v-model="emailModal.updateData.email_message" class="form-control" rows="5" max-rows="5">
                      </b-form-textarea>
                  </div>
                  <div>
                    <p>{{t('labelDocsSelectedForSending', 'labelDocsSelectedForSending')}}: {{emailModal.docuData.docsChecked.length}}</p>
                  </div>
                </template>
                <template v-else>
                  <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
                  <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
                </template>
              </template>
              <ResponseInfo v-if="getResponseInfo.responseName == 'modalEmailDocView'" class="mt-1"></ResponseInfo>
              <template v-if="getResponseInfo.restricted">
                <p class="text-center">{{t('docEmailModalNoPermissionToSendTheFollowing','docEmailModalNoPermissionToSendTheFollowing')}}</p>
                <figure class="text-center">
                  <figcaption>{{t('labelDocuments', 'labelDocuments')}}</figcaption>
                  <ul>
                    <li v-for="docId in getResponseInfo.restricted" v-bind:key="docId" >id: {{ docId }}</li>
                  </ul>
                </figure>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
          <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
            <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
          </button>
          <template v-if="((emailModal.modalData.entries == 'multi') && emailModal.docuData.docsChecked.length) || (emailModal.modalData.entries == 'single')">
            <button v-if="!buttonIsBusy && sendAvailable" aria-label="SendEmail" data-dismiss="modal" class="btn btn-primary" type="button" @click="sendEmail()">
              <fontAwesomeIcon :icon="['fa', 'paper-plane']" class="text-light mr-2"/> {{ t('sendButtonText', 'sendButtonText')}}
            </button>
            <b-button v-else variant="primary" disabled>
              <b-spinner v-if="buttonIsBusy" small type="grow"></b-spinner>
              <fontAwesomeIcon :icon="['fa', 'paper-plane']" class="text-light mr-2"/> {{ t('sendButtonText', 'sendButtonText')}}
            </b-button>
          </template>
      </template>
    </b-modal>
    <ModalAddressBook v-if="canOpenAddressBook" :contacts="recipientsBefore" ref="addressBook" :modal="this.subModal"/>
    <div v-if="this.subModal['modalData'].open" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'
import ModalAddressBook from '@/components/Documents_Search/ModalAddressBook.vue'

export default {
  name: 'ModalEmailDoc',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'modalCreator',
    'subModal'
  ],
  provide() {
    return {
      changeRecipients: this.changeRecipients,
      userLevel: this.userLevel
    }
  },
  data () {
    return {
      emailModal: {},
      buttonIsBusy: false,
      modalIsBusy: false,
      loaderBusy: true,
      canOpenAddressBook: false,
      recipientsBefore: []
      /*
      subModal: {
        modalData: {},
        itemData: {},
        updateData: {}
      }*/
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    userLevel: {
      get(){
        return this.$store.getters['getUserLevel']
      }
    },
    clientEmailAddress: {
      get(){
        return this.$store.getters['addressBookStore/getClientEmailAddress']
      }
    },
    prePopulatedEmails: {
      get() {
        return this.$store.getters['addressBookStore/getPrePopulatedEmails']
      }
    },
    subject: {
      get() {
        return this.$store.getters['addressBookStore/getSubject']
      }
    },
    modalParent() {
      return this.subModal['modalData'].parent
    },
    sendAvailable: {
      get() {
        return this.recipientsBefore.length
      }
    },
  },
  methods:{
    updateContacts() {
      let emailsString = this.emailModal.updateData.email_to

      if (emailsString) {
        emailsString = emailsString.split(',').map(function(item) {
          return item.replace(/\s/g, '');
        });
      } else {
        emailsString = []
      }

      let emails = new Set(emailsString)
      emails = [... emails]

      this.recipientsBefore = emails
      this.emailModal.updateData.email_to = emails.toString()
    },
    clearModal() {
      this.$refs.addressBook.resetAddressBook()
      this.canOpenAddressBook = false
    },
    changeRecipients(recipientsList) {
      this.modalIsBusy = true
      if(Array.isArray(recipientsList)) {
        let removeable = []
        if(this.recipientsBefore.length) {
          for (let i = 0; i < this.recipientsBefore.length; i++) {
            if(!recipientsList.includes(this.recipientsBefore[i])) {
              removeable.push(this.recipientsBefore[i])
            }
          }
          this.recipientsBefore = recipientsList
        } else {
          this.recipientsBefore = recipientsList
        }

        let emailsString = this.emailModal.updateData.email_to
        if(emailsString) {
          emailsString = emailsString.split(",")
        } else {
          emailsString = []
        }
        emailsString = emailsString.concat(recipientsList)
        let emails = new Set(emailsString)
        emails = [... emails]
        if(removeable.length) {
          emails = emails.filter(function(value, index, arr){ return (removeable.includes(value)) ? null : value})
        }
        this.emailModal.updateData.email_to = emails.toString()
      } else {
        this.emailModal.updateData.email_to = recipientsList
      }
      this.modalIsBusy = false
    },
    fetchAdditionalInfo(entries) {
      this.$store.dispatch('alertClearResponse')
      this.modalIsBusy = true
      this.canOpenAddressBook = true

      this.$store.dispatch('addressBookStore/getClientEmailAddress',{
        userLevel: this.userLevel,
        docId: this.emailModal.docuData.docsChecked,
      }).finally(() => {
        this.modalIsBusy = false
        this.emailFrom = this.clientEmailAddress
        this.emailModal.updateData.email_from = this.clientEmailAddress
        this.emailModal.updateData.email_subject = this.subject
        this.changeRecipients(this.prePopulatedEmails)
      })
    },
    sendEmail() {
      this.buttonIsBusy = true
      this.$store.dispatch('alertClearResponse')

      this.$store.dispatch('documentToolsStore/handleDocumentTool', {
        action: 'emailDocument',
        documents: this.emailModal.docuData.docsChecked || this.emailModal.docuData.id,
        email_to: this.emailModal.updateData.email_to,
        email_from: this.emailModal.updateData.email_from,
        email_subject: this.emailModal.updateData.email_subject,
        email_message: this.emailModal.updateData.email_message,
        //doc_levels: this.emailModal.updateData.doc_levels,
        //doc_id: this.emailModal.docuData.id,
        wm: this.emailModal.modalData.wm,
        perm_wm_allowed: this.emailModal.modalData.perm_wm_allowed
      })
      .then(() => {
          this.buttonIsBusy = false
          let responseStatus = this.getResponseInfo.status
          if(responseStatus != 'error'){
            this.$refs['email-modal'].hide()
          }
      })
    },
    /*
    loaderStopped() {
      this.loaderBusy = false
    }*/
  },
  created() {
    this.emailModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading,
    ModalAddressBook
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #emailModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
.modal-open #emailModal___BV_modal_outer_ >>> .modal-content{
  min-width: 800px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #emailModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 600px;
  overflow-y: scroll;
}
.text-lightgray{
  color: lightgray;
}
.text-size-large{
  font-size: 1.5rem;
}
.text-size-normal{
  font-size: 1rem;
}
</style>
